<template>
    <div>
        <div v-if="dialog" id="ca-dialog-wrap" @click="dialog = false">
            <div id="ca-dialog" @click.stop>
                <ComplianceAlertsForm
                    :rhythm_id="rhythm_id"
                    :companyName="companyName"
                    @close="dialog = false"
                />
            </div>
        </div>

        <slot :on="{click: () => dialog = true }"></slot>
    </div>
</template>
<script>
import ComplianceAlertsForm from './ComplianceAlertsForm.vue';
export default {
    components: {
        ComplianceAlertsForm
    },
    props: {
        rhythm_id: {
            type: String,
            required: true
        },
        companyName: {
            type: String,
            required: true
        }
    },
    data: () => ({
        dialog: false,
    })
}
</script>

<style>
#ca-dialog-wrap {
    background-color: rgba(0, 0, 0, 0.25);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    width: 100vw;
    height: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 10000000;
}

#ca-dialog {
    background-color: #fff;
    border-radius: 12px;
    overflow: hidden;
}
</style>